import {
    ChangeDetectionStrategy,
    Component,
    ChangeDetectorRef,
    Output,
    Input,
    EventEmitter,
} from "@angular/core";

export type MoqViolation = { gtin: string; moq: number; quantity: number };

@Component({
    selector: "vsf-upload-cart-csv",
    templateUrl: "./upload-cart-csv.component.html",
    styleUrls: ["./upload-cart-csv.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadCartCsvComponent {
    @Output() failedProductGtinsChange = new EventEmitter<string[]>();
    @Output() moqViolationsChange = new EventEmitter<MoqViolation[]>();
    @Input() customClass = "";
    @Input() borderedToolbar = false;
    @Input() buttonLabel = "Upload a cart";
    @Input() consolidatedFeedPricingIds: number[] = [];
    @Input() consolidatedFeedImport = false;
    @Input() failedProductGtins: string[] = [];
    @Input() moqViolations: MoqViolation[] = [];

    isImporting = false;
    isModalVisible = false;

    constructor(private cd: ChangeDetectorRef) {}

    openUploadModal() {
        this.isModalVisible = true;
        this.cd.markForCheck();
    }

    closeUploadModal() {
        this.isModalVisible = false;
        this.cd.markForCheck();
    }

    onUploadSuccess(result: {
        successfulCount: number;
        failedProductGtins: string[];
        moqViolations: MoqViolation[];
    }) {
        this.failedProductGtins = result.failedProductGtins;
        this.moqViolations = result.moqViolations || [];
        this.failedProductGtinsChange.emit(this.failedProductGtins);
        this.moqViolationsChange.emit(this.moqViolations);
        this.closeUploadModal();
    }
}
